import { FormikState } from 'formik';
import React, { FC, useEffect, useState } from 'react'
import { PLATFORM_FIELD, PlatformDataType } from 'src/interfaces/Platform.interface'
import { RECIPE_FORM_DATA } from 'src/interfaces/Template.interface';
import { getPlatformFieldOtherTemplatesAsync } from 'src/redux/actions/templateAndPricingActions';
import { useAppDispatch } from 'src/redux/storeHooks';


type AdditionalTemplateMappingItemProps = {
  item:PLATFORM_FIELD
  selectedSecondaryPlatform: PlatformDataType | null
  otherFieldIndex:number
  values:RECIPE_FORM_DATA
  handleChange:(e: string | React.ChangeEvent<any>) => void;
  setFormikState: (f: FormikState<RECIPE_FORM_DATA> | ((prevState: FormikState<RECIPE_FORM_DATA>) => FormikState<RECIPE_FORM_DATA>), cb?: (() => void) | undefined) => void
  prefetchedOptions?: { id: number; name: string }[]
}

const AdditionalTemplateMappingItem:FC<AdditionalTemplateMappingItemProps> = ({
item,
selectedSecondaryPlatform,
otherFieldIndex,
values,
handleChange,
setFormikState,
prefetchedOptions = [],

}) => {

  const [otherTemplateFieldDataOptions, setOtherTemplateFieldDataOptions] = useState(prefetchedOptions)
  const [otherTemplateFieldDataOptionsLoader, setOtherTemplateFieldDataOptionsLoader] = useState(false)
  const [isFieldItemsFetched, setIsFieldItemsFetched] = useState(prefetchedOptions.length > 0)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (prefetchedOptions.length) {
      setOtherTemplateFieldDataOptions(prefetchedOptions)
      setIsFieldItemsFetched(true)
    }
  }, [prefetchedOptions])

  const getOtherFieldTemplateDataOptions = (fieldId: number) => {
    if(!isFieldItemsFetched){
      setOtherTemplateFieldDataOptionsLoader(true)
      dispatch(getPlatformFieldOtherTemplatesAsync({platform_id:selectedSecondaryPlatform?.id!+'', field_id: String(fieldId)}))
      .then((response)=>{
        if(response.payload?.results){
          setOtherTemplateFieldDataOptions(response.payload.results)
        }
        setIsFieldItemsFetched(true)
        setOtherTemplateFieldDataOptionsLoader(false)
      })
    }
  }


  useEffect(() => {
    if(item.id && !prefetchedOptions.length){
      getOtherFieldTemplateDataOptions(item.id)
    }
  }, [item.id, prefetchedOptions.length])
  
  const selectedTemplateId = values.other_templates.find((it)=>(it?.fieldId==item.id))?.template_id

  return(
    <div className='col-12 col-lg-4 d-flex flex-column gap-2'>
      <label className='form-label mb-0'><span className={item?.isRequired ? 'required-sm' : ''}>{item.display_name}</span></label>
      <select
        id='dropdown'
        disabled={otherTemplateFieldDataOptionsLoader}
        className='form-select'
        name={`other_templates${otherFieldIndex}[template_id]`}
        value={selectedTemplateId ?? ''}
        onChange={(e) => {
          const updatedTemplates = [...values.other_templates];            
          const existingIndex = updatedTemplates.findIndex((it) => it.fieldId === item.id);
          
          const newEntry = {
            id: updatedTemplates[existingIndex]?.id ?? null,
            template_id: Number(e.target.value),
            fieldId: item.id,
          };

          if (existingIndex !== -1) {
            updatedTemplates[existingIndex] = newEntry;
          } else {
            updatedTemplates.push(newEntry);
          }

          setFormikState((prev) => ({
            ...prev,
            values: {
              ...prev.values,
              other_templates: updatedTemplates,
            },
          }));
        }}
        onClick={()=>getOtherFieldTemplateDataOptions(item.id)}
      >
        <option value=''>{otherTemplateFieldDataOptionsLoader ? 'Loading...' : '-- Please Select --'}</option>
        {otherTemplateFieldDataOptions.length > 0 && otherTemplateFieldDataOptions.map((option:any, index) => {
          return (
            <option key={'otherfieldTemplate' + index} value={option?.id}>
              {option?.name}
            </option>
          )
        })}
      </select>
    </div>
  )
}

export default AdditionalTemplateMappingItem
